module.exports = __webpack_public_path__ + "static/media/Translations_color.e9e4c8d1.svg";